/**
 * Normaliza uma string numérica e retorna um número.
 * @param {string|number} value
 * @returns {number}
 */
export function toNumber(value) {
  if (typeof value === "number") return value;

  // Remove espaços e símbolos não numéricos (exceto , . -)
  let str = String(value).replace(/[^\d.,-]/g, '').trim();

  // Se a string tiver tanto . quanto ,
  // - Se o último separador for vírgula: formato brasileiro (5.000,00)
  // - Se o último separador for ponto: formato americano (5,000.00)
  const lastDot = str.lastIndexOf('.');
  const lastComma = str.lastIndexOf(',');

  if (lastComma > lastDot) {
    // Provavelmente formato brasileiro: milhar = ".", decimal = ","
    str = str
      .replace(/\./g, '')       // remove pontos (milhares)
      .replace(/,/g, '.');      // troca vírgula por ponto (decimal)
  } else if (lastDot > lastComma) {
    // Provavelmente formato americano: milhar = ",", decimal = "."
    str = str
      .replace(/,/g, '');       // remove vírgulas (milhares)
    // ponto já é decimal
  } else {
    // Só tem um tipo de separador ou nenhum
    // Tenta interpretar o padrão mais provável
    if (str.includes(',')) {
      // Se tem vírgula e não tem ponto, trata como decimal brasileiro
      str = str.replace(/\./g, '').replace(/,/g, '.');
    }
    // Se só tem ponto, deixa como está
  }

  const num = Number(str);
  return Number.isNaN(num) ? 0 : num;
}
